interface ChipIconProps {
  size?: number;
  className?: string;
}

/**
 * Простая, но узнаваемая иконка покерной фишки — используется везде,
 * где отображается баланс/сумма в фишках (шапка, профиль, бай-ин, места игроков),
 * чтобы визуально отличать "фишки" от просто чисел.
 */
export function ChipIcon({ size = 14, className = '' }: ChipIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} fill="none">
      <circle cx="12" cy="12" r="10.5" fill="url(#chipGoldGrad)" stroke="#7a5a1a" strokeWidth="0.75" />
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="#0b0d0f" strokeWidth="1.1" strokeDasharray="2.6 2.6" opacity="0.55" />
      <circle cx="12" cy="12" r="4.2" fill="#0b0d0f" opacity="0.85" />
      <circle cx="12" cy="12" r="4.2" fill="none" stroke="#f2cf6d" strokeWidth="0.6" opacity="0.7" />
      <defs>
        <radialGradient id="chipGoldGrad" cx="35%" cy="30%" r="75%">
          <stop offset="0%" stopColor="#f7e2a4" />
          <stop offset="55%" stopColor="#e0b64a" />
          <stop offset="100%" stopColor="#a87c22" />
        </radialGradient>
      </defs>
    </svg>
  );
}
